/**
 * Copyright 2021 Olympe S.A.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Brick, registerBrick } from 'olympe';

/**
## Description
Removes whitespace from both ends of a string. Whitespace in this context is all the whitespace characters (space, tab, no-break space, etc.) and all the line terminator characters (LF, CR, etc.).
Use trim js function: See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String
 ## Inputs
 | Name | Type | Description |
 | --- | :---: | --- |
 | s | String | The string to trim |
## Outputs
| Name | Type | Description |
| --- | :---: | --- |
| s.trim() | String | Trimmed string |

**/
export default class TrimString extends Brick {

    /**
     * @protected
     * @param {!BrickContext} context
     * @param {string} s
     * @param {function(string)} setResult
     */
    update(context, [s], [setResult]) {
        setResult(String(s).trim());
    }
}

registerBrick('01717ca521db5a9c3c7c', TrimString);

